<script setup lang="ts">
import { MMText } from '@mm-frontend/mm-web-ui-kit';

defineProps<{
  label: string;
  textColor?: string;
  backgroundColor?: string;
}>();
</script>

<template>
  <div class="mm-badge" :style="{ backgroundColor: backgroundColor, color: textColor }">
    <div v-if="$slots.icon" class="mm-badge__icon">
      <slot name="icon" />
    </div>

    <MMText font="Caption M/Regular" class="mm-badge__label">
      {{ label }}
    </MMText>
  </div>
</template>

<style scoped lang="stylus">
.mm-badge
  display flex
  gap 4px
  padding 0 6px
  align-items center
  height 18px
  border-radius 100px

  &__icon
    font-size 13px
    display flex
    align-items center

  &__label
    color inherit
    display -webkit-box
    -webkit-line-clamp 1
    -webkit-box-orient vertical
    overflow hidden
</style>
